import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlPacketsTable extends Layout {
    labelPacketsHeader: Label;
    panelPacketsHeader: Panel;
    sourceMCPnetPackets: DataSource;
    tablePackets: Table;
}
